import React, { useState } from "react";
import { browserHistory, Link } from "react-router";
import moment from "moment";
import { Checkbox, TableCell, TableRow, Tooltip, } from "@material-ui/core";
import { VisibilityOutlined, DeleteOutline, Edit } from '@material-ui/icons';
import RevertIcon from "../../../assets/images/Revert_Icon.svg"
import { checkPermission } from "../../../utils_v2";
import { displayDateFormat } from "../../../../constants";
import { trackActivity } from "../../../../utils/mixpanel";
import { RevisionHistory } from "../../../shared_elements";

const AircraftTypesList = ({ item, index, onEditFn, onDelete, onRevert, toggleBulkOps, bulkIds }) => {

    const [showMore, setShowMore] = useState({});
    const toggleDescription = (field) => {
        setShowMore({
            ...showMore,
            [field]: !showMore[field]
        })
    }

    return (
        <>
            <TableRow style={{cursor:'pointer'}} onClick={() => {browserHistory.push(`/config-data/aircraftTypes/View/${item.id}`); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Type', item_type: 'Table Row', event_type: 'Item Clicked', event_desc: `Clicked on table row from Aircraft type Listing` })}} key={index} className={item?.deleted_at ? "grey-out" : ''}>
                <TableCell style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1, }}>
                    <ul className="list-inline flex-centered" style={{ width: '160px' }}>
                        {checkPermission('config_data', 'aircraft_types', 'D') &&  <li className="list-inline-item hover-inline last-icon" onClick={(e) => { e.stopPropagation();}}>
                            <Checkbox checked={bulkIds.includes(item?.id)} onChange={(e) => {toggleBulkOps(item, e.target.checked) }} color="primary" size="small" />
                        </li>}
                        <li className='list-inline-item hover-inline' style={{ cursor: 'pointer', verticalAlign: 'middle' }} onClick={(e) => e.stopPropagation()}>
                            <RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdaircrafttype/`} queryParams={{ action: '0,1,2', object_id: item?.id }} hideLinkage />
                        </li>
                        <li className="list-inline-item hover-inline last-icon" onClick={(e) => {e.preventDefault(); e.stopPropagation(); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Type', item_type: 'View Button', event_type: 'Item Clicked', event_desc: `Clicked on view button from Aircraft type Listing` })}} style={{ marginTop: "5px" }}>
                            <Tooltip title='Veiw' arrow><Link to={`/config-data/aircraftTypes/View/${item.id}`} fontSize="small" classname="back-icon" style={{ color: "#3f51b5" }}><VisibilityOutlined color="primary" fontSize="small" style={{ verticalAlign: 'top' }} /></Link></Tooltip>
                        </li>
                        {!item?.deleted_at &&  checkPermission('config_data', 'aircraft_types', 'U')  ?
                            <li className="list-inline-item hover-inline" onClick={(e) => {e.preventDefault(); e.stopPropagation();onEditFn();trackActivity('Console Management', { page_title: 'Config Data : Aircraft Type', item_type: 'Edit Button', event_type: 'Item Clicked', event_desc: `Clicked on Edit button to open Edit Aircraft Type Modal`})}}>
                                <Tooltip title='Edit' arrow><Edit color="primary" fontSize="small" /></Tooltip>
                            </li>
                            : null}
                        {item?.deleted_at && checkPermission('config_data', 'aircraft_types', 'RVT')?
                            <li className="list-inline-item hover-inline" >
                                <Tooltip title='Revert' arrow>
                                    <img
                                        src={RevertIcon}
                                        alt="Revert Icon"
                                        onClick={(e) => {e.preventDefault(); e.stopPropagation(); onRevert({ modal: true, data: item?.id });trackActivity('Console Management', { page_title: 'Config Data : Aircraft Type', item_type: 'Revert Button', event_type: 'Item Clicked', event_desc: `Clicked on Revert button to open Revert Aircraft type Modal` })}}
                                        style={{ width: "1rem", height: "1rem", cursor: 'pointer', fontSize: "1.25rem", margin:'4px' }}
                                        className="last-icon"
                                    />
                                </Tooltip>
                            </li>
                            : null}
                        {!item?.deleted_at  && checkPermission('config_data', 'aircraft_types', 'D')?
                            <li className="list-inline-item hover-inline" onClick={(e) => {e.preventDefault(); e.stopPropagation();onDelete({ modal: true, data: item});trackActivity('Console Management', { page_title: 'Config Data : Aircraft Type', item_type: 'Delete Button', event_type: 'Item Clicked', event_desc: `Clicked on Delete button to open Delete Aircraft type Modal` })}}>
                                <Tooltip title='Delete' arrow><DeleteOutline color="secondary" fontSize="small" /></Tooltip>
                            </li>
                            : null}
                    </ul>
                </TableCell>
                <TableCell><div style={{ width: '100px' }}>{item?.name || '--'}</div></TableCell>
                <TableCell><div style={{ width: '120px' }}>{item?.no_of_engines || '--'}</div></TableCell>
                <TableCell><div style={{ width: '120px' }}>{item?.no_of_landing_gears || '--'}</div></TableCell>
                <TableCell><div style={{ width: '140px' }}>{item?.aircraft_family?.name || '--'}</div></TableCell>
                <TableCell><div style={{ width: '150px' }}>{item?.aircraft_body_type?.label || '--'}</div></TableCell>
                <TableCell><div style={{ width: '100px' }}>{item?.has_propeller === true ? "Yes" : "No"}</div></TableCell>
                <TableCell><div style={{ width: '100px' }}>{item?.has_apu === true ? "Yes" : "No"}</div></TableCell>
                <TableCell>
                    <div style={{ width: '140px' }}>
                        {item?.created_by?.name || '--'}
                        {item?.created_by?.name ?
                            <p style={{ fontSize: '11px', opacity: '0.8' }}>{moment(item?.created_at).format(displayDateFormat)}</p> : null
                        }
                    </div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '140px' }}>
                        {item?.updated_by?.name || '--'}
                        {item?.updated_by?.name ?
                            <p style={{ fontSize: '11px', opacity: '0.8' }}>{moment(item?.updated_at).format(displayDateFormat)}</p> : null
                        }
                    </div>
                </TableCell>
                <TableCell onClick={(e) => { e.stopPropagation();}} >
					{item?.remarks && item?.remarks?.length > 30 ? (
						<div style={{ width: '200px' }}>
							{showMore[item?.field] ? (
								<span>
									<span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.replace(/\n/g, '<br />') }} />
									<a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}less </a>
								</span>
							) : (
								<span>
									<span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.substring(0, 25).replace(/\n/g, '<br />'), }} />
									<a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}..more </a>
								</span>
							)}
						</div>
					) : (
						<div dangerouslySetInnerHTML={{ __html: item?.remarks || '--', }} />
					)}
                </TableCell>
            </TableRow>
        </>
    )
}
export default AircraftTypesList;